import React from 'react';
import { Helmet } from 'react-helmet';

import ScheduleDemoSection from '../components/common/sections/ScheduleDemoSection';
import SolutionsSection from '../components/common/sections/SolutionsSection';
import Subscribe from '../components/common/sections/SubscribeSection';
import Banner from '../components/home/Banner';
import CustomerExperience from '../components/home/CustomerExperience';
import EasyCommerce from '../components/home/EasyCommerce';
import PersonalizedExperiences from '../components/home/PersonalizedExperiences';
import StreamlineWorkflows from '../components/home/StreamlineWorkflows';
import Wineries from '../components/home/Wineries';
import Layout from '../components/layout/Layout';

const IndexPage = () => (
  <Layout title="Modern Commerce for Wineries">
    <Helmet>
      <meta
        name="google-site-verification"
        content="3d6x6z2m77O_0fwz-A-sLWz2Ax4kCZc260MJ1KJltH0"
      />
    </Helmet>
    <Banner />
    <Wineries />
    <CustomerExperience />
    <PersonalizedExperiences />
    <EasyCommerce />
    <StreamlineWorkflows />
    <SolutionsSection />
    <ScheduleDemoSection />
    <Subscribe />
  </Layout>
);

export default IndexPage;
